import React, { useCallback, useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  Divider,
  Avatar,
  CardContent,
  CardActions,
  Button,
  Tab,
  List,
  Tabs,
  Box,
  Typography,
  Link,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import ArticleIcon from '@mui/icons-material/Article';
import { useAsyncFunc } from '@inner-source/cis-shared/hooks';
import { ErrorMessage, NoData } from '@inner-source/cis-shared/components';
import { NewsList } from '../../../../components';
import { NewsSkeleton } from './components';
import { getPagesByLabel } from '@inner-source/cis-shared/services';

const confluenceUrl = process.env.NX_CONFLUENCE_URL + '/news';

const News = () => {
  const [pages, setPages] = useState();

  const [doGetPages, loading, error] = useAsyncFunc(
    
    useCallback(async () => {
      if (!pages) {
        const response = await getPagesByLabel({ label: "news", limit: 5 });
        setPages(response && response.pages);
      }
    }, [pages]),
  );

  useEffect(() => {
    doGetPages();
  }, [doGetPages]);

  return (
    <Card variant="outlined" sx={{ display: 'flex', flex: '1 1 auto', flexDirection: 'column' }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'rgb(1,112,192)' }}>
            <ArticleIcon />
          </Avatar>
        }
        title={<Typography variant="h6">News</Typography>}
      />
      <Divider />
      <CardContent sx={{ pt: 0, display: 'flex', flexDirection: 'column', flex: 1 }}>
          {error && <ErrorMessage onRetry={doGetPages} />}
          {!error && loading && <NewsSkeleton />}
          {!error && !loading && pages && pages.length === 0 && <NoData />}
          {!error && !loading && pages && pages.length > 0 && <NewsList pages={pages} />}
      </CardContent>
      <Divider />
      <CardActions sx={{ pl: 3, display: 'flex' }}>
        <Button variant="text" color="primary" component={Link} href={confluenceUrl} target="_blank">
          See all
        </Button>
      </CardActions>
    </Card>
  );
};

export default News;
